var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Photoshop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.28,11c-1.62,0-3.16,0-4.21.08-.13,0-.36.08-.36.2V28.8c0,.15.07.2.2.2H12.4c.15,0,.2-.07.2-.2V22.54c.44,0,.65,0,1.27,0,3.69,0,6.69-1.78,6.69-5.92C20.56,13.48,18.8,11,14.28,11Zm-.34,9a11.61,11.61,0,0,1-1.32,0V13.64c.29,0,.91-.05,1.56-.05,2.17,0,3.46,1.05,3.46,3.12C17.64,19.3,15.84,20,13.94,20Zm16.38,5.28c0,2.61-2,4-4.7,4a7.12,7.12,0,0,1-3.35-.7c-.11-.05-.13-.13-.13-.26V25.9c0-.16.08-.21.2-.13a6.08,6.08,0,0,0,3.28,1c1.3,0,1.84-.54,1.84-1.28s-.38-1.11-2-2c-2.32-1.11-3.29-2.24-3.29-4.12,0-2.11,1.65-3.86,4.51-3.86a7.42,7.42,0,0,1,2.93.46.35.35,0,0,1,.16.32v2.24c0,.14-.08.22-.24.17A5.5,5.5,0,0,0,26.65,18c-1.29,0-1.73.66-1.73,1.2s.3,1,2,1.89C29.52,22.31,30.32,23.5,30.32,25.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.f6d29781d2b58f765741deb17e6b4438.svg";
export { ForwardRef as ReactComponent };